import {ReportRequestParametersObjectObject} from 'common/api/api.ts'
import {CommonRoutes} from 'common/context/commonRoutes.ts'
import {FormMode} from 'common/util/Util.tsx'

import {ReportFormAdmin} from '../report/ReportFormAdmin.tsx'

export const TrackerEventStatsAdmin = () => (
  <ReportFormAdmin
    mode={FormMode.create}
    reportType={ReportRequestParametersObjectObject.TypeEnum.Tracker}
    savedReportBaseRoute={CommonRoutes.TRACKER_EVENT_REPORT}
    title="New Tracker Report"
  />
)
